import { render, staticRenderFns } from "./SubscriptionDeptors.vue?vue&type=template&id=6cedb217&"
import script from "./SubscriptionDeptors.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDeptors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports